import type { Match } from '@uefadigital/panenka';
import { PkButton, PkIcon } from '@uefadigital/panenka-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { useGetLineUpQuery } from 'api/fspApi';
import { LineUps } from 'components/LineUps';
import { LineUpsField } from 'components/LineUpsField';
import { routes } from 'routes';
import type { LineUps as LineUp } from 'types/ApiResponseInterfaces';
import type { ConfigCompetition } from 'utils/config';

interface FieldSizeData {
  desktop: number;
  mobile: number;
  desktopJerseySize: number;
  mobileJerseySize: number;
}

interface LineUpsOverviewData {
  match: Match;
  isDesktop: boolean;
  fieldSize: FieldSizeData;
  competition?: ConfigCompetition;
}

export const LineUpsOverview = ({ match, isDesktop, fieldSize, competition }: LineUpsOverviewData) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const lineUpsRedirect = () => {
    const link = `${location.pathname}/${routes.lineUps}`.replace(/\/{2,}/g, '/');

    navigate(link);
  };

  const { data: lineUps = {} as LineUp } = useGetLineUpQuery(match.id);

  const hasLineUpsPositions =
    lineUps?.homeTeam?.field[0]?.fieldCoordinate &&
    lineUps?.homeTeam?.field[0]?.fieldCoordinate.x !== 0 &&
    lineUps?.homeTeam?.field[0]?.fieldCoordinate.y !== 0 &&
    lineUps?.awayTeam?.field[0]?.fieldCoordinate &&
    lineUps?.awayTeam?.field[0]?.fieldCoordinate.x !== 0 &&
    lineUps?.awayTeam?.field[0]?.fieldCoordinate.y !== 0;

  return (
    <div className="pk-px--m pk-py--xl pk-d--flex pk-flex--column">
      <div className="pk-mb--xl pk-font-size--xl pk-line-height--sd pk-font-style--normal pk-text--text-01 pk-text--text-01 pk-font--comp-bold">
        {t('line_ups')}
      </div>
      <div>
        {hasLineUpsPositions ? (
          <LineUpsField
            match={match}
            previousMatch={false}
            isDesktop={isDesktop}
            fieldSize={fieldSize}
            competition={competition}
          />
        ) : (
          <LineUps
            noPosition={!hasLineUpsPositions}
            lineUps={lineUps}
            isOverview
            competition={competition}
            match={match}
            isDesktop={isDesktop}
            fieldSize={fieldSize}
          />
        )}
      </div>
      <div className="pk-pt--m pk-pt-md--l pk-align-self--end">
        <PkButton appearance="text" onClick={lineUpsRedirect}>
          <span>{t('see_detailed_line_ups')}</span>
          <PkIcon name="navigation-chevron-right" />
        </PkButton>
      </div>
    </div>
  );
};
